import React, { useEffect, useState } from 'react'
import "./Navbar.scss"
import { navLinks, socialIcons } from '../../Data'
import { HiMenuAlt4, HiX } from "react-icons/hi";
import { motion } from 'framer-motion'
import {Link} from 'react-scroll';


const Navbar = () => {
  const [scroll, setScroll] = useState(false);
  const [toggle, setToggle] = useState(false);


  const menuVariants = {
    hidden: {
      scale: 0
    },
    visible: {
      scale: 50,
      transition: {
        type: "tween",
        duration: 0.5,
      }
    }
  }

  const navLinkVariants = {
    hidden: {
      display: "none",
      opacity: 0
    },
    visible: {
      opacity: 1,
      y: -30,
      transition: {
        delay: 0.7
      }
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 20)
    })
  }, [])
  return (
    <motion.div
      initial={{ y: -25 }}
      // whileInView={{}}
      whileInView={{ y: -5 }}
      transition={{ duration: 1 }}
      className={scroll ? "header active" : "header"}
    >
      <div className="Nav_container">
        <motion.div
          className="logo"
          drag
          dragConstraints={{ left: 0, top: 0, right: 0, bottom: 0 }}
          dragElastic={0.7}
        >
          <h3>A</h3>
          {/* <img src={logo} alt="logo" /> */}
        </motion.div>
        <ul className='nav_links'>
          {
            navLinks.map((navlink, index) => {
              return <li key={index}><Link to={`${navlink}`} spy={true} smooth={true} offset={0} duration={500}>{navlink}</Link></li>
            })
          }
        </ul>
        <div className='social_icons'>
          {
            socialIcons.map((socialIcon, index) => {
              return (
                <div key={index}>
                  <a href={socialIcon.link} target='blank'>{socialIcon.icon}</a>
                </div>
              )
            })
          }
        </div>
        {/* mobile menu start */}
        <div className="menu">
          <HiMenuAlt4 onClick={() => setToggle(true)} />
        </div>

        <motion.div className="closeMenu"
          variants={menuVariants}
          initial="hidden" animate={toggle ? "visible" : "hidden"}
        >
        </motion.div>

        <motion.div
          variants={navLinkVariants}
          animate={toggle ? "visible" : "hidden"}
          className="menuX"
        >
          <HiX onClick={() => setToggle(false)} />
          {navLinks.map((navlink, index) => {
            return <li key={index}>
              <a href={`#${navlink}`} onClick={() => setToggle(false)}>{navlink}</a>
            </li>
          })}
        </motion.div>

      </div>
    </motion.div>
  )
}

export default Navbar